import { render } from "./SetCategory.vue?vue&type=template&id=62f30bf5"
import script from "./SetCategory.vue?vue&type=script&lang=js"
export * from "./SetCategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__